import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "panel"]
  static classes = ["active"]
  static values = {
    default: { type: String, default: "" }
  }

  connect() {
    const defaultTab = this.defaultValue || this.buttonTargets[0]?.dataset.tabsName
    if (defaultTab) {
      this.show(defaultTab)
    }
  }

  select(event) {
    event.preventDefault()
    const tabName = event.currentTarget.dataset.tabsName
    this.show(tabName)
  }

  show(name) {
    this.buttonTargets.forEach(button => {
      const isActive = button.dataset.tabsName === name
      button.setAttribute("aria-selected", isActive)

      if (this.hasActiveClass) {
        this.activeClasses.forEach(cls => button.classList.toggle(cls, isActive))
      }
    })

    this.panelTargets.forEach(panel => {
      const isActive = panel.dataset.tabsName === name
      panel.classList.toggle("hidden", !isActive)
    })
  }
}
